import React from "react";
const Heart = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M12.6668 9.33333C13.6602 8.36 14.6668 7.19333 14.6668 5.66667C14.6668 4.69421 14.2805 3.76158 13.5929 3.07394C12.9053 2.38631 11.9726 2 11.0002 2C9.82683 2 9.00016 2.33333 8.00016 3.33333C7.00016 2.33333 6.1735 2 5.00016 2C4.0277 2 3.09507 2.38631 2.40744 3.07394C1.7198 3.76158 1.3335 4.69421 1.3335 5.66667C1.3335 7.2 2.3335 8.36667 3.3335 9.33333L8.00016 14L12.6668 9.33333Z"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.00039 3.33398L6.02706 5.30732C5.89161 5.44179 5.7841 5.60173 5.71074 5.77794C5.63738 5.95414 5.59961 6.14312 5.59961 6.33398C5.59961 6.52485 5.63738 6.71383 5.71074 6.89003C5.7841 7.06624 5.89161 7.22618 6.02706 7.36065C6.57373 7.90732 7.44706 7.92732 8.02706 7.40732L9.40706 6.14065C9.75296 5.82678 10.2033 5.65291 10.6704 5.65291C11.1375 5.65291 11.5878 5.82678 11.9337 6.14065L13.9071 7.91398M12.0004 10.0007L10.6671 8.66732M10.0004 12.0007L8.66706 10.6673"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default Heart;
